import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { PortalComponent } from './portals/portal.component';
import { SharedModule } from './shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { CitiesComponent } from './portals/entry-component/cities/cities.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { InstaCitiModule } from './portals/instaciti/instaciti.module';
import { BizspotsModule } from './bizspots/bizspots.module';
import { AutomobileModule } from './bizspots/automobile/automobile.module';
import { Market1Module } from './bizspots/market1/market1.module';
import { RealEstateModule } from './bizspots/real-estate/real-estate.module';
import { SocietyModule } from './bizspots/society/society.module';
import { PortalBinderModule } from './portal-binder-module/portal-binder.module';
import { PortalModule } from '@angular/cdk/portal';
import { EmCityModule } from './portals/emcity/emcity.module';
import { EmCity02Module } from './portals/emcity-02/emcity.module';
import { InstacitiMallModule } from './portals/instaciti-mall/instaciti-mall.module';
import { InstacitiNewModule } from './portals/instaciti-new/instaciti-new.module';
import { InstacitiEducationModule } from './portals/instaciti-education/instaciti-education.module';
import { PublicRoutingModule } from './public/public-routing.module';
import { PublicModule } from './public/public.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { OwlModule } from 'ngx-owl-carousel';
@NgModule({
  declarations: [
    AppComponent,
    PortalComponent,
    //CitiesComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    MatAutocompleteModule,  
    MatButtonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OwlModule,
    // InstaCitiModule,
    // BizspotsModule,
    // AutomobileModule,
    // Market1Module,
    // RealEstateModule,
    // RealEstateModule,
    // SocietyModule,
    // PortalBinderModule,
    // PortalModule,
    // EmCityModule,
    // EmCity02Module,
    // InstacitiMallModule,
    // InstacitiNewModule,
    // InstacitiEducationModule,
    PublicRoutingModule,
    // InstacitiMallModule,
    InstacitiNewModule,
    PublicRoutingModule,
    PublicModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  entryComponents: [ 
    CitiesComponent 
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
